
/**
 * 输入内容格式化类型定义
 */
export enum FormatInputType {
  /** cdKey兑换码 */
  cdKey = 'cdKey',
  /** 银行卡 */
  cardNum = 'cardNum',
  /** 默认，不做任何格式化处理 */
  defalut = 'defalut'
}

/**
 * cdKey 兑换码"去空格后"的最大有效字符数。
 * 业务上 cdkey 最长 16 位；URL 预填、手动截断都按此长度判断。
 */
export const CDKEY_RAW_MAX_LENGTH = 16;

/**
 * cdKey 兑换码"含空格分隔符"的展示长度，专用于 `<input maxlength>` 属性。
 *
 * 计算关系：16 位有效字符 + 3 个每 4 位插入的空格分隔符 = 19。
 * 浏览器原生 `maxlength` 计数包含空格，因此这里用展示长度而非有效字符数；
 * 外部使用方传入 `maxlength` Prop 时同样语义为"含空格的展示长度"。
 */
export const CDKEY_DISPLAY_MAX_LENGTH = CDKEY_RAW_MAX_LENGTH + Math.floor((CDKEY_RAW_MAX_LENGTH - 1) / 4);

interface FormatConfigItem {
  type: string;
  format: {
    input: (value: string) => string,
    output: (value: string) => string
  }
}

/** 格式化配置 */
const inputFormatConfig: { [v: string]: FormatConfigItem } = {
  [FormatInputType.defalut]: {
    type: 'text',
    format: {
      input: (value: string) => value,
      output: (value: string) => value,
    },
  },
  [FormatInputType.cdKey]: {
    type: 'text',
    format: {
      /** 每4位用空格隔开 */
      input: (value: string) => value.replace(/[\s ]+/g, '').replace(/(.{4})/g, '$1 ')
        .trim(),
      /** 去掉空格 */
      output: (value: string) => value.replace(/[\s ]+/g, ''),
    },
  },
  [FormatInputType.cardNum]: {
    type: 'number',
    format: {
      /** 每4位用空格隔开 */
      input: (value: string) => value.replace(/[\s ]+/g, '').replace(/(.{4})/g, '$1 ')
        .trim(),
      /** 去掉空格 */
      output: (value: string) => value.replace(/[\s ]+/g, ''),
    },
  },
};

export default inputFormatConfig;
